import React__default from 'react';

const grid = "_grid_fyqoq_1";
const styles = {
	grid: grid
};

const isNumber = (value) => typeof value === "number";
const Grid = ({ alignItems = "stretch", gap = 0, columns = "none", children }) => {
  return React__default.createElement("div", { className: styles.grid, style: {
    "--_zds-grid-align-items": alignItems,
    "--_zds-grid-gap": isNumber(gap) ? `${gap}px` : gap,
    "--_zds-grid-templatecolumns": isNumber(columns) ? `repeat(${columns}, 1fr)` : columns
  }, "data-zds": true }, children);
};

export { Grid };
//# sourceMappingURL=Grid.es.js.map
